function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import CustomerCareKeys from '../../../../../locales/keys';
import { SUBSCRIBER_ADJUSTMENT_DUE_DAYS_LIMITS, SUBSCRIBER_PAYMENT_DUE_DAYS_LIMITS } from '../../../../createCustomerPopup/create.customer.popup.constants';
import { ACCOUNTING_METHODS } from '../../../../../components/createCustomer/billingInformationSection/billing.information.section.constants';
import { BILL_CYCLE_TYPES } from '../../../../../customercare.constants';
var CustomerBillingCycleUpdateModalComponent = /*#__PURE__*/function () {
  function CustomerBillingCycleUpdateModalComponent($filter) {
    _classCallCheck(this, CustomerBillingCycleUpdateModalComponent);
    Object.assign(this, {
      $filter: $filter,
      ACCOUNTING_METHODS: ACCOUNTING_METHODS,
      CustomerCareKeys: CustomerCareKeys,
      billCycleFrequency: null,
      billCycleOptions: [],
      billCycleSelectOptionTemplate: require('invision-ui/lib/components/formControls/selectors/singleselect/optionTemplates/text.with.dot.delimited.subtext.html'),
      BILL_CYCLE_TYPES: BILL_CYCLE_TYPES,
      onBillCycleSelectOptionSelected: this.onBillCycleSelectOptionSelected.bind(this),
      onAdjustmentDueDaysChange: this.onAdjustmentDueDaysChange.bind(this),
      onPaymentDueDaysChange: this.onPaymentDueDaysChange.bind(this),
      selectedBillCycle: null,
      subscriberAdjustmentDueDaysLimits: SUBSCRIBER_ADJUSTMENT_DUE_DAYS_LIMITS,
      subscriberPaymentDueDaysLimits: SUBSCRIBER_PAYMENT_DUE_DAYS_LIMITS,
      updateAccountingMethod: this.updateAccountingMethod.bind(this)
    });
  }
  return _createClass(CustomerBillingCycleUpdateModalComponent, [{
    key: "$onInit",
    value: function $onInit() {
      if (!this.selectedBillCycle) {
        this.billCycleFrequency = null;
      }
      this.customerAdjustmentDueDays = this.adjustmentDueDays;
      this.customerPaymentDueDays = this.paymentDueDays;
      this.updatedAccountingMethod = this.customerAccountingMethod;
      this.validateIsSelectedBillingCycleIsSame();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      var _changesObj$billCycle,
        _this = this;
      if (changesObj !== null && changesObj !== void 0 && (_changesObj$billCycle = changesObj.billCycles) !== null && _changesObj$billCycle !== void 0 && _changesObj$billCycle.currentValue) {
        (changesObj.billCycles.currentValue || []).forEach(function (billCycle) {
          var _changesObj$currentBi, _changesObj$currentBi2;
          var billCycleOption = Object.assign({}, billCycle, {
            text: billCycle.name,
            selected: false,
            subtextList: billCycle.billDate && billCycle.paymentDueDate ? [i18n.translate(CustomerCareKeys.BILL_CYCLE.NEXT_BILL_DATE, {
              next_bill_date: _this.$filter('localShortDate')(billCycle.billDate)
            }), i18n.translate(CustomerCareKeys.BILL_CYCLE.PAYMENT_DUE_DATE, {
              payment_due_date: _this.$filter('localShortDate')(billCycle.paymentDueDate)
            })] : []
          });
          if ((_this.currentBillCycleDetails || {}).id === billCycle.id) {
            billCycleOption.selected = true;
            _this.onBillCycleSelectOptionSelected(billCycleOption);
          }
          if (!!(changesObj !== null && changesObj !== void 0 && (_changesObj$currentBi = changesObj.currentBillCycleDetails) !== null && _changesObj$currentBi !== void 0 && (_changesObj$currentBi2 = _changesObj$currentBi.currentValue) !== null && _changesObj$currentBi2 !== void 0 && _changesObj$currentBi2.type)) {
            var _changesObj$currentBi3, _changesObj$currentBi4, _changesObj$currentBi5, _changesObj$currentBi6;
            if ((changesObj === null || changesObj === void 0 ? void 0 : (_changesObj$currentBi3 = changesObj.currentBillCycleDetails) === null || _changesObj$currentBi3 === void 0 ? void 0 : (_changesObj$currentBi4 = _changesObj$currentBi3.currentValue) === null || _changesObj$currentBi4 === void 0 ? void 0 : _changesObj$currentBi4.type) === BILL_CYCLE_TYPES.THREE_STEP && billCycleOption.type === BILL_CYCLE_TYPES.THREE_STEP || (changesObj === null || changesObj === void 0 ? void 0 : (_changesObj$currentBi5 = changesObj.currentBillCycleDetails) === null || _changesObj$currentBi5 === void 0 ? void 0 : (_changesObj$currentBi6 = _changesObj$currentBi5.currentValue) === null || _changesObj$currentBi6 === void 0 ? void 0 : _changesObj$currentBi6.type) === BILL_CYCLE_TYPES.STANDARD && billCycleOption.type === BILL_CYCLE_TYPES.STANDARD) {
              _this.billCycleOptions.push(billCycleOption);
            }
          } else {
            _this.billCycleOptions.push(billCycleOption);
          }
        });
      }
    }
  }, {
    key: "onSubmitForm",
    value: function onSubmitForm() {
      if (this.CustomerBillCycleUpdateForm.$valid) {
        this.onSubmit()(this.selectedBillCycle, this.customerPaymentDueDays, this.customerAdjustmentDueDays, this.updatedAccountingMethod);
      }
    }
  }, {
    key: "onBillCycleSelectOptionSelected",
    value: function onBillCycleSelectOptionSelected(selectedOption) {
      this.billCycleOptions.forEach(function (billCycleOption) {
        billCycleOption.selected = false;
      });
      selectedOption.selected = true;
      this.selectedBillCycle = selectedOption;
      this.billCycleFrequency = selectedOption.frequency;
      this.validateIsSelectedBillingCycleIsSame();
    }
  }, {
    key: "getBillCycleBillDate",
    value: function getBillCycleBillDate() {
      if (this.selectedBillCycle) {
        return this.selectedBillCycle.billDate ? i18n.translate(CustomerCareKeys.PROFILE_PAGE.NEXT_BILL_DATE, {
          billDate: this.selectedBillCycle.billDate
        }) : i18n.translate(CustomerCareKeys.PROFILE_PAGE.DATE_UNAVAILABLE);
      }
      return null;
    }
  }, {
    key: "validateIsSelectedBillingCycleIsSame",
    value: function validateIsSelectedBillingCycleIsSame() {
      this.disableSaveBtn = true;
      if (!this.currentBillCycleDetails && this.selectedBillCycle || this.selectedBillCycle && this.selectedBillCycle.id !== this.currentBillCycleDetails.id || convertStringToNumber(this.customerPaymentDueDays) !== this.paymentDueDays || convertStringToNumber(this.customerAdjustmentDueDays) !== this.adjustmentDueDays) {
        this.disableSaveBtn = false;
      } else {
        this.disableSaveBtn = true;
      }
    }
  }, {
    key: "onAdjustmentDueDaysChange",
    value: function onAdjustmentDueDaysChange(adjustmentDueDays) {
      if (adjustmentDueDays !== null) {
        this.customerAdjustmentDueDays = adjustmentDueDays;
        this.validateIsSelectedBillingCycleIsSame();
      }
    }
  }, {
    key: "onPaymentDueDaysChange",
    value: function onPaymentDueDaysChange(paymentDueDays) {
      if (paymentDueDays !== null) {
        this.customerPaymentDueDays = paymentDueDays;
        this.validateIsSelectedBillingCycleIsSame();
      }
    }
  }, {
    key: "updateAccountingMethod",
    value: function updateAccountingMethod(selectedAccountingMethod) {
      this.updatedAccountingMethod = selectedAccountingMethod.value;
      this.disableSaveBtn = false;
    }
  }]);
}();
export default {
  bindings: {
    adjustmentDueDays: '<',
    billCycles: '<',
    currentBillCycleDetails: '<',
    customerAccountingMethod: '<',
    displayAdjustmentDueDays: '<',
    displayPaymentDueDays: '<',
    isAccountingMethodEditable: '<',
    isBillCycleChangeAllowed: '<',
    isBillCycleLoading: '<',
    onClose: '&',
    onSubmit: '&',
    paymentDueDays: '<',
    updatePaymentDueDays: '&'
  },
  template: require('./customer.billing.cycle.update.modal.html'),
  controller: CustomerBillingCycleUpdateModalComponent,
  controllerAs: 'CustomerBillingCycleUpdate'
};